import React from "react";

//Importing Material UI stuff
import { makeStyles } from "@material-ui/core/styles";
import { OutlinedButton } from "../../components/Buttons";

//Importing Components
import { Grid, TextField, Typography, Card } from "@material-ui/core";

import style from "./style";

const useStyles = makeStyles(style);

function ContactPage() {
  const classes = useStyles();

  return (
    <div className={classes.contactPage}>
      {/* Hero Section */}
      <Grid container className={`${classes.section} ${classes.heroSection}`}>
        <div className={classes.heroSectionContent}>
          <Typography data-aos="fade-in" variant="h2" gutterBottom className={classes.title}>
            Contact Me
          </Typography>
          <Typography data-aos="fade-in" variant="h6" gutterBottom className={classes.description}>
            If you have any questions for me, I would love to hear from you.
            Feel free to contact me and I’ll get back to you.
          </Typography>
          <Grid container className={classes.contactGrid}>
            <form data-aos="fade-in" id="myForm" className={classes.contactForm} action="https://formsubmit.co/devrajchatribin9978@gmail.com" target="_blank" autoComplete="off" method="POST" required>
              <TextField
                classes={{ root: classes.textFieldOutline }}
                data-aos="fade-in"
                id="standard-basic"
                color="primary"
                label="Name"
                name="name"
                required
              />
              <TextField
                classes={{ root: classes.textFieldOutline }}
                data-aos="fade-in"
                id="standard-basic"
                color="primary"
                label="Email"
                name="email"
                type="email"
                required
              />
              <TextField
                classes={{ root: classes.textFieldOutline }}
                data-aos="fade-in"
                id="standard-basic"
                color="primary"
                label="Subject"
                name="subject"
                required
              />
              <TextField
                classes={{ root: classes.textFieldOutline }}
                data-aos="fade-in"
                id="standard-basic"
                color="primary"
                label="Message"
                name="message"
                multiline
                rows={4}
                required
              />
              <input type="hidden" name="_captcha" value="false" />
              <input type="hidden" name="_template" value="table" />
              <input type="hidden" name="_subject" value="Contact Form | Portfolio" />
              <input type="hidden" name="_autoresponse" value="Thank you. Your message was sent successfully!"/>
              {/* <input type="hidden" name="_next" value="https://devrajchatribin.co/contact" /> */}
              <div data-aos="fade-in" className="hover-detect">
                <OutlinedButton 
                  type="Submit"
                  size="large"
                >
                  <Typography variant="h6">Submit</Typography>
                </OutlinedButton>
              </div>
            </form>
            
            <div className={classes.options}>
              <Card data-aos="fade-in" className={classes.optionBlock}>
                <Typography
                  variant="h5"
                  gutterBottom
                  className={classes.optionTitle}
                  data-aos="fade-in"
                >
                  Support Me
                </Typography>
                <Typography
                  variant="subtitle1"
                  gutterBottom
                  className={classes.optionInfo}
                  data-aos="fade-in"
                >
                  It would mean a lot to me if you could support me. It will
                  help me build more amazing projects!
                </Typography>
                <a data-aos="fade-in" href="https://www.buymeacoffee.com/devrajchatribin" target="_blank" rel="noreferrer" className="hover-detect">
                  <OutlinedButton size="large" className={classes.btn}>
                    <Typography variant="h6">Support Me</Typography>
                  </OutlinedButton>
                </a>
              </Card>
              <Card data-aos="fade-in" className={classes.optionBlock}>
                <Typography
                  variant="h5"
                  gutterBottom
                  className={classes.optionTitle}
                  data-aos="fade-in"
                >
                  Hire Me
                </Typography>
                <Typography
                  variant="subtitle1"
                  gutterBottom
                  className={classes.optionInfo}
                  data-aos="fade-in"
                >
                  If you like my work and would like to hire me or collaborate on projects than feel free to reach out.
                </Typography>
                <a data-aos="fade-in" href="mailto:devrajchatribin9978@gmail.com?subject=Hire Me | Portfolio" target="_blank" rel="noreferrer" className="hover-detect">
                  <OutlinedButton size="large" className={classes.btn}>
                    <Typography variant="h6">Hire Me</Typography>
                  </OutlinedButton>
                </a>
              </Card>
            </div>
          </Grid>
        </div>
      </Grid>


    </div>
  );
}

export default ContactPage;
